<template>
  <div class="boxContainer" :class="mode">
    <div class="inputArea">
        <div class="inputTextBox">
          <el-input
            type="textarea"
            placeholder="尽量具体描述你想要的画面，如中国画风格的插画，主题为一只小鸟，背景有树有天空，主画面圆形，白色背景"
            v-model="text"
            maxlength="500"
            show-word-limit
            class="textArea"
            resize="none"
            rows="10"/>
          <p style="line-height: 20px;">
            示例：<span class="colorText">中国画</span>风格的插图，主体为一只<span class="colorText">小鸟</span>，背景<span class="colorText">有树有天空</span>，主画面<span class="colorText">圆形</span>，<span class="colorText">白色背景</span>。
          </p>
        </div>
        <el-divider border-style="dashed" />
        <div class="imageStyleArea">
          <span>请选择一个生成的画面风格：</span>
          <ImgStyleSelect @changeImg="handleChangeImg" :options="imgStyleOptions" :showBigImg="true"/>
        </div>
        <div class="outputConfigArea">
          <div class="outputSize">
            <div class="demonstration">图片生成尺寸：</div>
            <el-radio-group class="sizeSelect" v-model="size" size="small">
              <el-radio label="1024*1024">1:1</el-radio>
              <el-radio label="1280*720">16:9</el-radio>
              <el-radio label="720*1280">9:16</el-radio>
            </el-radio-group>
          </div>
          <div class="outputFolder">
            <span>保存位置：
              <el-tooltip :disabled="saveFolderName.length <= 9" effect="dark" :content="saveFolderName" placement="top">
                <span class="colorFolderName">{{ saveFolderName }}</span>
              </el-tooltip>
            </span>
            <el-button class="outputFolderButton" size="mini" @click="addFolder">修改</el-button>
          </div>
        </div>
        <el-button
          type="primary"
          class="generateButton"
          :loading="btnLoading"
          @click="handleSubmit">
          生成图像
        </el-button>
    </div>
    <div class="outputArea">
      <header class="outputHeader">
        <div class="contentArea">
          <el-tooltip v-if="backfillText.length > 0" :disabled="backfillText.length <= 5" :content="backfillText" placement="top">
            <span class="inputText">{{ backfillText }}</span>
          </el-tooltip>
          <span v-show="generatedImg.style" class="styleText">画面风格：{{ imgStyleMap[generatedImg.style] || '' }}</span>
        </div>
        <div class="buttonArea">
          <el-dropdown trigger="click" :disabled="isDisabledButton">
            <span class="el-dropdown-link">
              <img class="aiImg" :src="aiImg">智能处理
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :disabled="isDisabledButton" @click.native="remoteAiUse('image_enhancement')">图片智能清晰</el-dropdown-item>
              <el-dropdown-item :disabled="isDisabledButton" @click.native="remoteAiUse('image_enlargement')">图片智能放大</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            class="headerButton"
            type="text"
            size="mini"
            :disabled="isDisabledButton"
            @click="handleDownload">
            <i class="el-icon-download"/>下载图片
          </el-button>
          <el-button v-if="outputMode.includes('insert') && generatedImg.file_path"
            class="headerButton"
            type="text"
            size="mini"
            @click="insertMethod">
            <i class="iconfont">&#xe7f2;</i>插入
          </el-button>
          <el-button
            type="text"
            size="mini"
            :disabled="isDisabledButton"
            @click="handleReSubmit"
            class="headerButton">
            <i class="el-icon-refresh"/>重新生成
          </el-button>
        </div>
      </header>
      <div v-if="isShowText" class="outputShowArea">
        <div class="showTextArea">
          <h3>处理成功后结果将会显示在这里</h3>
          <br>
          <span>可点击【下载图片】使用或在【素材库】中找到处理完成的素材进行使用。</span>
        </div>
      </div>
      <div v-else-if="isShowLoading" class="outputShowArea">
        <img style="width: 100px; height: 100px;" :src="loadingImg" alt="Animated GTF"/>
        <span class="showPendingText">结果正在生成中...</span>
      </div>
      <div
        v-else-if="isShowImage && generatedImg.file_path"
        :class="['outputShowArea', 'generateImagArea']"
        :style="{
          'background-image': `url(${generatedImg.file_path})`,
          'background-size': 'contain',
          'display': 'block',
          'background-repeat': 'no-repeat',
          'background-position': 'center'
        }">
      </div>
      <div
        v-else-if="isShowErrorMessage"
        class="errorMessage">
        <img :src="failImg"/>
        图片生成有误
      </div>
    </div>

    <el-dialog
      title="保存位置"
      :append-to-body="true"
      :visible.sync="dialogFolderVisible"
      width="600px"
      :before-close="cancelFolder"
    >
      <div class="dialogTree">
        <folderTree
          ref="MugedaAiFolderTree"
        />
      </div>
      <div  style="text-align: right; margin: 10px 0 0 0">
        <el-button size="small" class="class-cancel" @click="cancelFolder()">
          取消
        </el-button>
        <el-button size="small" type="primary" @click="confirmFolder()">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import folderTree from '@/layout/components/folderTree.vue';
import ImgStyleSelect from '../ImageStyleSelect/index.vue';
import axios from 'axios';
import {
  imgStyleMap,
  ImgStyle,
  SizeType,
  imgStyleOptions
}  from './config';
import { GeneratedServiceStatus, SUCCESS_STATUS } from '../config'
import loadingImg from '/imgs/AILoading.png';
import aiImg from '/imgs/AI图标.png';
import failImg from '/imgs/fail.png'

import { useGetIdentifyInfo } from '@/hooks/useIdentifyInfo';
import { getIdentifyInfo } from "@/api/common"

export default {
  name: 'TextGenerateImageTool',
  components: {
    folderTree,
    ImgStyleSelect
  },
  props: {
    mode: {
      type: String,
    },
    aiType: {
      type: String,
    },
    inputMode: {
      type: Array,
      default: () => [],
    },
    outputMode: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      source: axios.CancelToken.source(),
      text: '',
      saveFolderName: '默认文件夹',
      saveFolderId: '',
      size: SizeType["1:1"],
      dialogFolderVisible: false,
      styleName: imgStyleMap[ImgStyle.AUTO],
      style: ImgStyle.AUTO,

      generatedImg: {},
      usageLogId: undefined,

      backfillText: '',
      backfillStyleName: '',

      btnLoading: false,
      loading: false,

      pollingTimer: null,

      // script导入对象
      loadingImg,
      aiImg,
      imgStyleMap,
      SizeType,
      failImg,
      imgStyleOptions,
      identifyInfo: {},
    };
  },

  watch: {
    usageLogId: function(newVal) {
      if (newVal) {
        // 关闭前一次轮询，生成新的source,开始轮训
        this.stopPolling();
        this.generateNewSource();
        this.startPolling();
      } else {
        this.stopPolling();
      }
    }
  },

  computed: {
    isShowText() {
      // 展示引导文字条件：没有任务ID，没有图片路径，没有图片描述
      return !this.usageLogId && !this.generatedImg.file_path && !this.generatedImg.text
    },

    isShowLoading() {
      return !!this.usageLogId
    },

    isShowImage() {
      // 展示图片条件：图片生成成功时；图片生成有误时，同样没有file_path，此时也要展示Image
      return !!this.generatedImg.file_path || (!this.generatedImg.file_path && ![GeneratedServiceStatus.FAILED, GeneratedServiceStatus.CANCELED, GeneratedServiceStatus.SUSPENDED, GeneratedServiceStatus.UNKNOWN].includes(this.generatedImg.status))
    },

    isShowErrorMessage() {
      return (!this.generatedImg.file_path && [GeneratedServiceStatus.FAILED, GeneratedServiceStatus.CANCELED, GeneratedServiceStatus.SUSPENDED, GeneratedServiceStatus.UNKNOWN].includes(this.generatedImg.status))
    },

    isDisabledButton() {
      return this.btnLoading || !this.generatedImg.file_path;
    }
  },

  async mounted() {
    this.identifyInfo = await useGetIdentifyInfo(this.aiType, getIdentifyInfo, this)
    this.$emit('emitAccountInfo', this.identifyInfo)
  },

  methods: {
    generateNewSource() {
      const source = axios.CancelToken.source();

      this.source = source;
      // 暂时缓存目前选择的文本和类型
      this.backfillText = this.text
      this.generatedImg.style = this.style
    },

    handleChangeImg(style) {
      this.style = style;
    },

    async handleSubmit() {
      if(!this.text) {
        this.$message.error('请输入内容');

        return;
      }

      this.generatedImg = {};
      this.btnLoading  = true;
      this.backfillText = '';

      const params =  {
        text: this.text,
        style: this.style,
        size: this.size,
        folder_id: this.saveFolderId
      };


      const { data } = await axios.post('/index/text_generated_image/submit', params);

      if (data.status === SUCCESS_STATUS) {
        this.usageLogId = data?.data?.usage_log_id;
      } else {
        this.$message.error(data.error);
      }

      this.$emit('updateHistory');

      this.btnLoading  = false;
    },

    async handleReSubmit() {
      this.btnLoading  = true;
      this.generatedImg.file_path = undefined;

      const { text, size, style } = this.generatedImg;

      const params = {
        text,
        size,
        style,
        folder_id: this.saveFolderId
      };

      const { data } = await axios.post('/index/text_generated_image/submit', params);

      if (data.status === SUCCESS_STATUS) {
        this.usageLogId = data?.data?.usage_log_id;
      } else {
        this.$message.error(data.error);
      }

      this.$emit('updateHistory');

      this.btnLoading  = false;
    },

    async getGeneratedImg () {
      this.loading = true;

      try {
        const { data } = await axios.get('/index/text_generated_image/get_usage_log', {
          params: {
            usage_log_id: this.usageLogId
          },
          cancelToken: this.source.token
        });

        if (data.status === SUCCESS_STATUS) {
          this.generatedImg = data?.data;

          if (![GeneratedServiceStatus.PENDING, GeneratedServiceStatus.RUNNING].includes(data.data.status)) {
            this.usageLogId = undefined;
            this.$emit('updateHistory');
          }
        } else {
          this.$message.error(data.error);
          this.stopPolling();
        }
      } catch(err) {
        console.error(err)
      } finally {
        this.loading = false;
      }
    },

    startPolling() {
      this.pollingTimer = setInterval(() => {
        this.getGeneratedImg()
      }, 3000);
    },

    stopPolling() {
      clearInterval(this.pollingTimer);
    },

    addFolder() {
      this.dialogFolderVisible = true
      this.$nextTick(()=>{

        this.$refs.MugedaAiFolderTree.getAllFolders()
      })
    },

    cancelFolder() {
      this.dialogFolderVisible = false
    },

    confirmFolder() {
      const node = this.$refs.MugedaAiFolderTree.$refs.tree.getCurrentNode()
      if (!node) {
        this.$message({
          type: 'error',
          message: '请选择文件夹',
        })
        return
      }
      this.saveFolderName = node.label
      this.saveFolderId = node.id
      this.cancelFolder()
    },

    handleDownload() {
      const tag = document.createElement('a')
      tag.setAttribute('download', this.generatedImg.file_path)
      tag.href = this.generatedImg.file_path
      tag.click()
    },

    useHistory(item) {
      const { text, status, style, id } = item;

      this.backfillText = text;
      this.styleName = imgStyleMap[style];
      this.source.cancel('操作取消');

      if ([GeneratedServiceStatus.PENDING, GeneratedServiceStatus.RUNNING, ].includes(status)) {
        this.usageLogId = id;
      } else {
        this.usageLogId = undefined;
        this.loading = false;
      }

      this.generatedImg = item;
    },
    insertMethod() {
      const _data = { ...this.generatedImg, url: this.generatedImg.file_path}
      this.$emit('insertMethod', _data)
    },
    remoteAiUse(type){
      const _data = { ...this.generatedImg, url: this.generatedImg.file_path}
      // 依赖外部实现其他组件的调用
      this.$emit('remoteAiUse', type, _data)
    },
  },
  beforeDestroy() {
    this.source.cancel('操作取消');
    this.stopPolling()
  }
};
</script>

<style scoped lang="scss">
.iconfont {
  margin-right: 2px;
}
.boxContainer {
  width: 100%;
  height: 100%;
  display: flex;

  .inputArea {
      padding: 20px;
      min-width: 380px;
      max-width: 420px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;

      .inputTextBox {
        color: #999999;

        margin-bottom: -10px;
        .textArea {
          margin-bottom: 10px;
        }

        ::v-deep .el-textarea__inner {
          border: none;
          background: #F5F5F5;
          padding: 16px 15px;
        }

        ::v-deep .el-input__count {
          background: #F5F5F5;
        }

        .colorText {
          font-weight: bold;
          color: #666;
        }
      }

      ::v-deep .el-divider {
        background-color: #DDDDDD
      }

      .imageStyleArea {
        color: #333333;
        width: 100%;
        margin-top: -10px;
        margin-bottom: 10px;
      }

      .outputConfigArea {
        width: 100%;
        min-height: 80px;
        flex: 1;

        .outputFolder {
          margin-top: 16px;
          width: 70%;
          text-align: center;
          display: flex;

          .colorFolderName {
            display: inline-block;
            text-align: center;
            width: 120px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .outputFolderButton {
            margin-top: -5px
          }
        }

        .outputSize {
          width: 100%;
          min-width: 160px;
          display: flex;

          .demonstration {
            margin-top: 10px
          }

          .sizeSelect {
            margin-top: 10px;
          }
        }
      }


    .generateButton {
      margin-top: 20px;
      width: 100%;
    }
  }

  .outputArea {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 350px;
    position: relative;
    border-left: 1px solid #DDDDDD;

    .outputHeader {
      padding: 0 20px;
      height: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: #F5F5F5;

      .contentArea {
        min-width: 210px;
        max-width: 330px;
        display: flex;

        .inputText {
          display: inline-block;
          max-width: 60%;
          min-width: 130px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          line-height: 30px;
        }
        .styleText {
          margin-left: 10px;
          display: inline-block;
          min-width: 140px;
          max-width: 210px;
          line-height: 30px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }

      .buttonArea {
        min-width: 231px;
        color: #666666;
        display: flex;
        justify-content: flex-end;
        .el-dropdown-link {
          cursor: pointer;
          position: relative;
          bottom: 8px;
          font-size: 14px;

          .aiImg {
            position: relative;
            top: 10px
          }
        }

        ::v-deep .el-button--text:focus {
          background-color: transparent;
        }

        .el-button {
          color: #666666
        }

        .el-icon-arrow-down {
          font-size: 10px;
        }

        .headerButton{
          margin-left: 10px;
          font-size: 14px;
          text-align: center;
          color: #666;
          i {
            font-size: 18px;
            vertical-align: middle;
          }
          &:not(.is-disabled):hover {
            color: #FD7700;
          }
          .el-icon-download .el-icon-refresh {
            font-size: 20px;
          }
          &.is-disabled {
            color: #999;
          }
        }

        .el-button {
          border: none
        }

        .el-button:hover {
          background-color: transparent;
        }
        .el-button:active {
          background-color: transparent;
        }
      }
    }

    .outputShowArea {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .showPendingText {
        font-size: 18px;
        background-image: linear-gradient(to right, #E7B0E6 100%, #9371FF 100%, #49A3FF 100%);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
      }

      .showTextArea {
        min-width: 300px;
        padding: 20px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        h3 {
          color: #333;
          font-size: 20px;
        }
        span {
          color: #999;
          font-size: 14px;
        }
      }
    }

    .generateImagArea {
      width: 100%;
    }

    .errorMessage {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 14px;
    }
  }
}
.rich {
  border: 1px solid #DDDDDD;
  ::v-deep .imageStyleBox .imgBox .checkIcon {
    color: #409eff;
  }
  ::v-deep .imageStyleBox .imgBox .selectedImgDesc {
    color: #409eff;
  }
  .inputArea {
    .inputTextBox {
      ::v-deep .el-input__count {
        background: transparent;
      }
    }

    .outputConfigArea {
      .outputFolder {
        .colorFolderName {
          color: #409eff;
        }
      }
    }
  }
}
.h5 {
  border: 1px solid #444444;
  .inputArea {
    .inputTextBox {
      color: #eeeeee;
      ::v-deep .el-textarea__inner {
        border: none;
        background: #444;
        color: #999999
      }
      ::v-deep .el-input__count {
        background: #444;
        color: #999999
      }
      .colorText {
        color: #ccc;
      }
    }
    ::v-deep .el-divider {
      background-color: #666666;
    }
  }
  .outputArea {
    border-left: 1px solid #444444;
    .outputHeader {
      background: #444;
      color: #CCC;
    }
    .outputShowArea {
      .showTextArea {
        h3 {
          color: #CCCCCC;
        }
        span {
          color: #999999;
        }
      }
    }
    .buttonArea {
      color: #CCC !important;
      .el-button {
        color: #CCC !important;
      }
    }
  }

  ::v-deep .el-button:hover .el-button:active .el-button:focus {
    background: transparent;
  }
}
</style>
